// extracted by mini-css-extract-plugin
module.exports = {"CheckboxBadgeWrapper":"CheckboxBadge_CheckboxBadgeWrapper__qMLyZ","CheckboxBadge":"CheckboxBadge_CheckboxBadge__1_TTe"};